<template>
    <article
        class="model"
        :key="model.id"
        :style="{ backgroundImage: `url('${model.public_vertical_image_path['small']}')` }"
    >
        <router-link
            v-if="model.username"
            :to="{name: 'model.username', params: {username: '@'+model.username}}"
        >
        </router-link>
        <router-link
            v-else
            :to="{name: 'model.profile', params: {id: model.id}}"
        >
        </router-link>

        <div class="name">
            {{model.name}}
        </div >
    </article>
</template>

<script>
export default {
    props: {
        model: {
            type: Object,
            required: true,
        }
    }
}
</script>
<style scoped lang="scss">
@import '../../styles/variables';
.model{
    position: relative;
    width: 216px; // ratio = 1.777777778
    height: 384px; // ratio = 0.5625
    margin: 5px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    transition: all ease-in-out 100ms;

    @media(max-width: 768px){}
    @media(max-width: 469px){ width: 205px; height: 365px; }
    @media(max-width: 449px){ width: 180px; height: 320px; }
    @media(max-width: 399px){ width: 160px; height: 284px; }
    @media(max-width: 359px){ width: 130px; height: 230px; }
    @media(max-width: 299px){ width: 260px; height: 462px; }

    a{
        position: absolute;
        display: block;
        width: 100%;
        height: 100%;
        z-index: 1;
    }

    .name{
        position: absolute;
        bottom: 5px;
        left: 10px;
        color: #fff;
        font-size: 16px;
        text-shadow: 1px 1px 1px #000;
        text-transform: uppercase;
        @media(max-width: 768px){}
    }
}
</style>